<template>
  <div class="radio-button-group">
    <RadioButton
      v-for="{ label, value, checked, disabled, size } in config"
      v-bind="{ value, label, checked, disabled, size, group }"
      :key="value"
      class="radio-button-group__item"
      @change="handleChange"
    />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import RadioButton from '~/components/common/RadioButton/RadioButton.vue';

export default Vue.extend({
  name: 'RadioButtonGroup',
  components: {
    RadioButton,
  },
  props: {
    config: {
      type: Array,
      default: () => [],
      required: true,
    },
    group: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleChange({ value }: { value: unknown }) {
      this.$emit('change', value);
    },
  },
});
</script>

<style scoped lang="scss">
.radio-button-group {
  display: flex;
  flex-direction: column;

  &__item {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
